var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center mt-32"},[(!_vm.shop_order)?_c('div',[_c('memlist-spinner')],1):_c('div',[_c('PaymentStatusComponent',{attrs:{"order":_vm.shop_order}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }